import React, { ForwardRefRenderFunction, useImperativeHandle, forwardRef, useState } from "react";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { FiInfo } from "react-icons/fi";

import ConfirmationModal from "Components/Dialogs/ConfirmationModal";
import { Color } from "Components/Form/Button";

export const ConfirmationModalContent = styled("p")(() => ({
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: "1.5rem",
  "& span": {
    fontWeight: 700,
  },
}));

interface MoveConfirmationProps {
  isLoading: boolean;
  onSubmit: () => void;
}

export interface MoveConfirmationHandler {
  open: (data: string) => void;
  close: () => void;
}

const MoveConfirmationModal: ForwardRefRenderFunction<
  MoveConfirmationHandler,
  MoveConfirmationProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const { isLoading = false, onSubmit } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [object, setObject] = useState<string>("");

  const onOpen = (data: string) => {
    setOpen(true);
    setObject(data);
  };

  const onClose = () => {
    setOpen(false);
    setObject("");
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
    close: onClose,
  }));

  return (
    <ConfirmationModal
      open={open}
      closeModal={() => setOpen(false)}
      customColorSave={Color.WARNING}
      loading={isLoading}
      textSubmit={translate("move")}
      type={"warning"}
      title={translate("cellInUse")}
      submit={onSubmit}
      width="32.5rem !important"
      leftIconTitle={<FiInfo color="#12B76A" />}
      data-cy="confirmation-modal"
    >
      <div>
        <ConfirmationModalContent>
          {translate("the")} <span>{object}</span>{" "}
          {translate("isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow")}
        </ConfirmationModalContent>
      </div>
    </ConfirmationModal>
  );
};

export default forwardRef(MoveConfirmationModal);
